(function () {
  /**
   * Opens the native Loox Floating Reviews popup for #looxReviews links
   * without scrolling the page. Never opens a custom theme modal.
   * On product pages, always pass the product ID so only that product's reviews open.
   * Also locks page scroll while the Loox overlay is open (no double scrollbars).
   */
  var LOCK_CLASS = 'qeviq-loox-scroll-lock';
  var scrollLockY = 0;
  var scrollLocked = false;

  function getProductId(looxRoot) {
    if (looxRoot && looxRoot.getAttribute('data-product-id')) {
      return looxRoot.getAttribute('data-product-id');
    }

    if (window.LOOX && window.LOOX.productId) {
      return String(window.LOOX.productId);
    }

    var widget = document.querySelector('loox-snippets-widget[product-id]');
    if (widget && widget.getAttribute('product-id')) {
      return widget.getAttribute('product-id');
    }

    return null;
  }

  function isLooxOverlayOpen() {
    return !!document.querySelector('.loox-overlay, [id^="loox_overlay"], #looxModalFrame, iframe#looxModalFrame');
  }

  function lockPageScroll() {
    if (scrollLocked) return;

    scrollLockY = window.scrollY || window.pageYOffset || 0;
    scrollLocked = true;

    document.documentElement.classList.add(LOCK_CLASS);
    document.body.classList.add(LOCK_CLASS);
    document.body.classList.add('overflow-hidden');

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!scrollLocked) return;
    if (isLooxOverlayOpen()) return;

    scrollLocked = false;

    document.documentElement.classList.remove(LOCK_CLASS);
    document.body.classList.remove(LOCK_CLASS);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('loox-overlay-is-active');

    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    var y = scrollLockY || 0;
    // Avoid visible jump: restore without smooth scrolling.
    if (Math.abs((window.scrollY || window.pageYOffset || 0) - y) > 1) {
      window.scrollTo(0, y);
    }
  }

  function syncScrollLock() {
    if (isLooxOverlayOpen()) {
      lockPageScroll();
    } else {
      unlockPageScroll();
    }
  }

  function preventBackgroundScroll(event) {
    if (!scrollLocked) return;

    var overlay = event.target.closest && event.target.closest('.loox-overlay, [id^="loox_overlay"]');
    if (overlay) return;

    // Allow scrolling inside the Loox iframe / overlay only.
    if (event.target && event.target.tagName === 'IFRAME') return;

    event.preventDefault();
  }

  function openNativeLooxReviews(event) {
    var link = event.target.closest('a[href="#looxReviews"], a[href="#looxReviewsFrame"]');
    if (!link) return;

    event.preventDefault();

    var looxRoot = document.getElementById('looxReviews');
    var productId = getProductId(looxRoot);
    var isAggregate = looxRoot ? looxRoot.hasAttribute('data-loox-aggregate') : false;

    // Lock immediately so the page cannot scroll behind the opening overlay.
    lockPageScroll();

    if (window.LOOX) {
      if (!productId && isAggregate && typeof window.LOOX.openHCFloater === 'function') {
        window.LOOX.openHCFloater();
        window.setTimeout(syncScrollLock, 50);
        return;
      }

      if (productId && typeof window.LOOX.openHCFloater === 'function') {
        window.LOOX.openHCFloater(productId);
        window.setTimeout(syncScrollLock, 50);
        return;
      }

      if (typeof window.LOOX.openHCFloater === 'function') {
        window.LOOX.openHCFloater();
        window.setTimeout(syncScrollLock, 50);
        return;
      }

      if (typeof window.LOOX.openQV === 'function') {
        window.LOOX.openQV();
        window.setTimeout(syncScrollLock, 50);
        return;
      }
    }

    if (looxRoot) {
      looxRoot.click();
      window.setTimeout(syncScrollLock, 50);
      return;
    }

    unlockPageScroll();
  }

  function observeLooxOverlay() {
    if (window.__qeviqLooxScrollObserverBound) return;
    window.__qeviqLooxScrollObserverBound = true;

    var observer = new MutationObserver(function () {
      syncScrollLock();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });
    document.addEventListener('wheel', preventBackgroundScroll, { passive: false });

    // Escape / Loox close can remove overlay asynchronously.
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        window.setTimeout(syncScrollLock, 0);
      }
    });
  }

  function bindLooxReviewLinks() {
    if (window.__qeviqLooxPopupBound) return;
    window.__qeviqLooxPopupBound = true;
    document.addEventListener('click', openNativeLooxReviews);
    observeLooxOverlay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLooxReviewLinks);
  } else {
    bindLooxReviewLinks();
  }
})();
